import { useQuery } from "react-query";
import { publicRequest } from "utils";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import { useMeta } from "hooks";

export const useService = (id: string) => {
  const { language } = useSelector((state: RootState) => state.global);
  const { setMetaTags } = useMeta();

  const { data: service } = useQuery(
    [language, id, "service"],
    () =>
      publicRequest({
        url: `/api/service/${id}/${language}`,
        method: "get"
      }),
    {
      onSuccess: (res) => {
        setMetaTags(res?.data?.meta);
      }
    }
  );

  return {
    service: service?.data
  };
};
